// Direct variant fix - simplest possible solution
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    console.log('Direct Variant Fix loaded');
    
    // Only run on product pages
    if (!window.location.pathname.includes('/products/')) return;
    
    // Find variant radios or selects - these are Dawn theme specific components
    const variantRadios = document.querySelector('variant-radios');
    const variantSelects = document.querySelector('variant-selects');
    
    if (!variantRadios && !variantSelects) {
      console.log('No variant selectors found');
      return;
    }
    
    const variantComponent = variantRadios || variantSelects;
    console.log('Found variant component:', variantComponent.tagName);
    
    // Find all forms on the page
    const allForms = document.querySelectorAll('form[action*="/cart/add"]');
    console.log(`Found ${allForms.length} cart forms`);
    
    // Find the variant ID input
    let variantIdInput = null;
    allForms.forEach(form => {
      const input = form.querySelector('input[name="id"]');
      if (input) {
        variantIdInput = input;
        console.log('Found variant ID input:', input.value);
      }
    });
    
    if (!variantIdInput) {
      console.log('No variant ID input found');
      return;
    }
    
    // Track when variant selection changes
    variantComponent.addEventListener('change', function() {
      setTimeout(() => {
        console.log('Variant changed to:', variantIdInput.value);
      }, 50);
    });
    
    // Find submit buttons
    const submitButtons = document.querySelectorAll('button[name="add"], button[type="submit"], input[type="submit"]');
    console.log(`Found ${submitButtons.length} submit buttons`);
    
    // Replace all submit buttons with our own
    submitButtons.forEach((button, index) => {
      // Create a clone with the same appearance
      const clone = button.cloneNode(true);
      button.parentNode.replaceChild(clone, button);
      
      // Add our click handler
      clone.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Get the current variant ID
        const variantId = variantIdInput.value;
        const quantity = document.querySelector('input[name="quantity"]')?.value || 1;
        
        console.log(`Adding variant ${variantId} to cart`);
        
        // Show loading state
        const originalText = clone.textContent;
        clone.disabled = true;
        clone.textContent = 'Adding...';
        
        // Direct AJAX call
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity
          })
        })
        .then(response => response.json())
        .then(data => {
          console.log('Added to cart:', data);
          window.location.href = '/cart';
        })
        .catch(error => {
          console.error('Error:', error);
          clone.disabled = false;
          clone.textContent = originalText;
        });
      });
    });
    
    // Block all form submissions
    allForms.forEach(form => {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        console.log('Form submission blocked');
        return false;
      }, true);
    });
    
    console.log('Direct variant fix initialized');
  });
})();